var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4V5H3C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H9V8C9 8.55228 9.44772 9 10 9C10.5523 9 11 8.55228 11 8V4Z",
    fill: "#781D7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H14Z",
    fill: "#781D7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C16.5523 9 17 9.44772 17 10V14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14V13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H15V10C15 9.44772 15.4477 9 16 9Z",
    fill: "#781D7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 11.4477 19.4477 11 20 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H20C19.4477 13 19 12.5523 19 12Z",
    fill: "#781D7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16C7 15.4477 6.55228 15 6 15C5.44772 15 5 15.4477 5 16V17H3C2.44772 17 2 17.4477 2 18C2 18.5523 2.44772 19 3 19H5V20C5 20.5523 5.44772 21 6 21C6.55229 21 7 20.5523 7 20L7 16Z",
    fill: "#781D7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 17.4477 9.44772 17 10 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H10C9.44772 19 9 18.5523 9 18Z",
    fill: "#781D7E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 5.5,
    r: 4.5,
    fill: "#E9465E",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a9f7401a72cee0814172a482f6de5ef7.svg";
export { ForwardRef as ReactComponent };